import { render } from "./EcommercePage.vue?vue&type=template&id=fe224b9a&ts=true"
import script from "./EcommercePage.vue?vue&type=script&lang=ts"
export * from "./EcommercePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__